import React from 'react';
import { useBooking } from '../../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import FillPassengersNavigation from '../../../bookingNavigationSteps/FillPassengersNavigation';

function AutoNavigationTabItems() {
  const {
    departurePassengersForm,
    returnPassengersForm,
    statement,
    bookingData,
  } = useBooking();
  const isReturnWay = Boolean(bookingData?.return?.id);

  return [{
    key: isReturnWay ? 3 : 2,
    children: <FillPassengersNavigation
      departureForm={departurePassengersForm}
      returnForm={returnPassengersForm}
      showMobile
    />,
  }, {
    key: isReturnWay ? 4 : 3,
    children: isReturnWay ? (
      <FillPassengersNavigation
        departureForm={departurePassengersForm}
        returnForm={returnPassengersForm}
        showMobile
      />
    ) : (
      <FillPassengersNavigation
        statement={statement}
        showMobile
      />
    ),
  }, {
    key: isReturnWay ? 5 : 4,
    children: <FillPassengersNavigation
      statement={statement}
      showMobile
    />,
  },
  ];
}

export default AutoNavigationTabItems;
